<h2 mat-dialog-title>Vincular nova instituição</h2>
<mat-dialog-content class="mat-typography">
  <p>Veja abaixo as instituições disponíveis, se preferir, realize sua busca no campo abaixo:</p>
  <div class="row">
    <div class="col-xs-12">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Faça sua busca pela instituição ou cidade</mat-label>
        <input
          type="text"
          matInput
          [formControl]="searchControl"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          placeholder="Digite aqui sua busca pela instituição ou cidade"
        />

        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-card *ngIf="showAutocompletePanel" class="autocomplete-panel">
        <mat-list>
          <mat-list-item *ngFor="let suggestion of autocompleteSuggestions" (click)="selectSuggestion(suggestion)" class="suggestion-item">
            <mat-icon matListIcon>search</mat-icon>
            <div matLine>{{ suggestion }}</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
    </div>
  </div>

  <div *ngIf="searchControl.value && searchControl.value.length >= 3" class="results-count">
    {{ filteredLocations.length }} organização{{ filteredLocations.length !== 1 ? 'es' : '' }} encontrada{{
      filteredLocations.length !== 1 ? 's' : ''
    }}
  </div>

  <div class="row">
    <div class="col-xs-12 col-lg-6" *ngFor="let organization of filteredLocations">
      <mat-card>
        <div class="col-xs-12">
          <div class="desc">{{ organization.managingOrganization?.name || organization.name }}</div>
          <div class="desc">{{ getCity(organization.organization_id) }}</div>
        </div>
          
        <div class="col-xs-12 actions">
       
          <div class="col-sm-6 bt">
            <button mat-stroked-button color="primary" 
           
            (click)="openSelectProcedure(organization)">Vincular</button>
          </div>
          <div class="col-sm-6 bt">
            <button mat-stroked-button color="primary" (click)="openOrganizationDetailForm(organization)">Detalhes</button>
          </div>
        </div>
      
      </mat-card>
    </div>
  </div>

  <div *ngIf="searchControl.value && searchControl.value.length >= 3 && filteredLocations.length === 0" class="no-results">
    <mat-icon>search_off</mat-icon>
    <p>Nenhuma organização encontrada para "{{ searchControl.value }}"</p>
    <p class="suggestion">Tente buscar por outro termo ou verifique a ortografia.</p>
  </div>

   <div *ngIf="locations.length === 0" class="no-results">
    <mat-icon>search_off</mat-icon>
    <p>Ainda não há organizações cadastradas no sistema</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>
